import {PROGRAMS_FETCH_COMPLETED, PROGRAMS_FETCH_STARTED} from "../constants/Programs";

const initialState = {
  programs: [],
  hasLoaded: false,
  isFetching: false
};

export function programs(state = initialState, action) {
  switch (action.type) {
    case PROGRAMS_FETCH_STARTED:
      return {...state, isFetching: true};
    case PROGRAMS_FETCH_COMPLETED:
      return {...state ,programs: action.programs, hasLoaded: true, isFetching: false};
    default:
      return state;
  }
}

